<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForm"
            :label-position="'top'"
            style="display:flex;flex-wrap:wrap"
          >
            <span
              class="el-form-item__label"
              style="width: 80px;flex-shrink: 0;"
              >會員查询:</span
            >
            <el-form-item style="width: 100px">
              <el-select
                v-model="listMenuForm.selectValue"
                placeholder="请选择"
                style="width: 100px !important;"
              >
                <el-option label="會員編號" value="4"></el-option>
                <el-option label="會員賬號" value="1"></el-option>
                <el-option label="暱稱" value="0"></el-option>
                <el-option label="真實姓名" value="2"></el-option>
                <el-option label="手機號碼" value="3"></el-option>
                <el-option label="身份證號" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="searchItem">
              <el-input
                v-model="listMenuForm.nickname"
                placeholder="在左側選擇搜索類別"
              ></el-input>
            </el-form-item>
            <el-form-item label="地區：" class="searchItem">
              <el-input v-model="listMenuForm.area"></el-input>
            </el-form-item>
            <el-form-item label="會員狀態：" class="searchItem">
              <el-select
                v-model="listMenuForm.memberStatus"
                placeholder="請選擇類型"
              >
                <el-option label="全部" value="0"></el-option>
                <el-option label="VIP" value="1"></el-option>
                <el-option label="一般" value="2"></el-option>
                <el-option label="黑名單" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="實名認證：" class="searchItem">
              <el-select
                v-model="listMenuForm.authStatus"
                placeholder="請選擇類型"
              >
                <el-option label="全部" value="4"></el-option>
                <el-option label="未認證" value="0"></el-option>
                <el-option label="已認證" value="1"></el-option>
                <el-option label="審核中" value="2"></el-option>
                <el-option label="審核不通過" value="3"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="賬號狀態：" class="searchItem">
              <el-select
                v-model="type"
                placeholder="請選擇賬號狀態："
              >
                <el-option label="全部" :value=null></el-option>
                <el-option label="正常" value="0"></el-option>
                <el-option label="已注銷" value="1"></el-option>
                <el-option label="已刪除" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForm hidden-xl-only"
          >
            <el-form-item label="實名認證：" class="searchItem">
              <el-select
                v-model="listMenuForm.authStatus"
                placeholder="請選擇類型"
              >
                <el-option label="全部" value="4"></el-option>
                <el-option label="未認證" value="0"></el-option>
                <el-option label="已認證" value="1"></el-option>
                <el-option label="審核中" value="2"></el-option>
                <el-option label="審核不通過" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row> -->

      <div class="MenuBtnWrap" style="justify-content:space-between;">
        <div class="btn" @click="exportExcel()">導出所有會員</div>
        <div style="display:flex;">
          <div class="btn borderPurpleBtn" @click="badgeIssue()">徽章發放</div>
          <div class="btn borderPurpleBtn" @click="retroactiveIssue()">
            補簽卡發放
          </div>
          <div class="btn" @click="search()">查詢</div>
          <div class="btn borderBtn" @click="reset()">重置</div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          :data="userInfoList"
          height="660px"
          stripe
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in userInfoTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop == 'type'">
                <span>{{
                  scope.row[item.prop] == 1
                    ? "已注銷"
                    : scope.row[item.prop] == 2
                    ? "已刪除"
                    : "正常"
                }}</span>
              </div>

              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <!-- 右侧固定列 -->
          <el-table-column fixed="right" label="操作" width="280">
            <template slot-scope="scope">
              <el-button
                @click="toEdituser(scope.row.id,scope.row.type)"
                type="text"
                :disabled="scope.row.isDelete ? true : false"
                >查看</el-button
              >
              <el-button
                v-if="
                  (roleType.indexOf('ROLE_ADMIN') > -1 ||
                    roleType.indexOf('ROLE_SUPER_ADMIN') > -1) &&
                    scope.row.type === 0
                "
                @click="complainUser(scope.row)"
                type="text"
                >檢舉</el-button
              >
              <el-button
                v-if="scope.row.type === 0"
                @click="blackUser(scope.row.id, scope.row.email, 1)"
                :style="{
                  color:
                    scope.row.blackList == '1' || scope.row.blackList == '2'
                      ? '#909090'
                      : '#6c3dea'
                }"
                type="text"
                :disabled="
                  scope.row.blackList == '1' || scope.row.blackList == '2'
                    ? true
                    : false
                "
                >加入黑名單
              </el-button>
              <!-- <el-button v-if="scope.row.blackList=='1'"  @click="blackUser(scope.row.id, scope.row.email,0)" type="text" >移除黑名單</el-button> -->
              <el-dropdown style="margin-left: 5px;cursor:pointer"   v-if="scope.row.type === 0">
                <span style="color:#6c3dea">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button
                      @click="badgeManager(scope.row.id)"
                      type="text"
                      :disabled="scope.row.isDelete ? true : false"
                      >徽章管理</el-button
                    ></el-dropdown-item
                  >
                  <el-dropdown-item>
                    <el-button
                      @click="
                        getScreen(
                          scope.row.id,
                          scope.row.screenshot,
                          scope.row.email
                        )
                      "
                      type="text"
                      >{{
                        scope.row.screenshot == 0 ? "允许截屏" : "禁止截屏"
                      }}</el-button
                    >
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button
                      @click="delUser(scope.row.id, scope.row.email)"
                      type="text"
                      :disabled="scope.row.isDelete ? true : false"
                      >{{ scope.row.isDelete ? "已删除" : "刪除" }}</el-button
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 檢舉用戶理由 -->
    <div v-if="complainFlag" class="propWrap">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">提示信息</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="cancelComplain"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content" style="display:block;">
          <div class="el-message-box__message" style="margin-bottom:0.2rem;">
            <p style="text-align: left;">{{ complainTips }}</p>
          </div>

          <el-form>
            <el-form-item>
              <el-radio-group v-model="complainType">
                <div
                  v-for="(item, index) in typeNameArray"
                  :key="index"
                  style="margin-bottom:0.05rem;"
                >
                  <el-radio :label="item.type">
                    {{ item.name }}
                  </el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <p style="text-align: left;">
            檢舉後該用戶將在72小時內被禁言，是否確定檢舉該用戶？
          </p>
        </div>
        <div class="el-message-box__btns">
          <button
            @click="cancelComplain"
            type="button"
            class="el-button el-button--default el-button--small"
          >
            <span>取消</span>
          </button>
          <button
            @click="confirmComplainUser"
            type="button"
            class="el-button el-button--default el-button--small el-button--primary "
          >
            <span>確認</span>
          </button>
        </div>
      </div>
    </div>
    <!--加入黑名单-->
    <div v-if="addBlackFlag" class="propWrap">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">提示信息</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="cancelAddBlack"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content" style="display:block;">
          <div class="el-message-box__message" style="margin-bottom:0.2rem;">
            <p>{{ addBlacktips }}</p>
          </div>
          <el-form>
            <el-form-item label="禁用功能 ：">
              <el-checkbox-group
                v-model="checkBlackList"
                @change="handleCheckedTypeChange"
              >
                <el-checkbox :label="1">登錄</el-checkbox>
                <el-checkbox :label="2">評論</el-checkbox>
                <el-checkbox :label="5">活动报名</el-checkbox>
                <el-checkbox :label="7">粉絲發信</el-checkbox>
                <!-- <el-checkbox :label="3">發帖</el-checkbox>
                <el-checkbox :label="4">社區評論</el-checkbox> -->
              </el-checkbox-group>

              <!-- <el-radio-group v-model="blackType">
                  <el-radio :label="1">登錄</el-radio>
                  <el-radio :label="2">發言</el-radio>
              </el-radio-group> -->
            </el-form-item>
            <el-form-item label="禁用至 ：">
              <el-date-picker
                :picker-options="forbiddenOptions"
                v-model="downTime"
                type="datetime"
                @change="handleForbidTime"
                placeholder="選擇時間"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input
                type="textarea"
                autosize
                placeholder="請輸入加入黑名單原因"
                v-model="blackReason"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-message-box__btns">
          <button
            @click="cancelAddBlack"
            type="button"
            class="el-button el-button--default el-button--small"
          >
            <span>取消</span>
          </button>
          <button
            @click="addBlack(addBlackId, addBlackEmail)"
            type="button"
            class="el-button el-button--default el-button--small el-button--primary "
          >
            <span>確認</span>
          </button>
        </div>
      </div>
    </div>
    <!--徽章发放-->
    <div v-if="badgeIssueFlag" class="propWrap badge-form">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">徽章發放</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="closeBadgeIssueProp()"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div>
            <div class="el-message-content-item">
              <label>發放目標</label>
              <el-input
                type="textarea"
                style="width: 5.16rem;"
                placeholder="請輸入目標會員郵箱，一行一個最多1000個。"
                v-model="badgeIssueBody.list"
              ></el-input>
            </div>
            <div class="el-message-content-item flex-content">
              <div class="flex-item">
                <label>發放徽章種類</label>
                <el-select v-model="badgeIssueBody.mainType">
                  <el-option
                    v-for="item in mainSelect"
                    :key="item.mainName"
                    :label="item.mainName"
                    :value="item.mainType"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="flex-item">
                <label>徽章名稱</label>
                <el-select v-model="badgeIssueBody.activityType">
                  <el-option
                    v-for="item in activitySelect[badgeIssueBody.mainType]"
                    :key="item.activityName"
                    :label="item.activityName"
                    :value="item.activityType"
                  >
                  </el-option>
                  <template slot="empty">
                    <div class="el-select-dropdown__empty">
                      請先選擇發放徽章種類
                    </div>
                  </template>
                </el-select>
              </div>
              <div class="flex-item">
                <label>選擇徽章等級</label>
                <el-select
                  v-model="badgeIssueBody.subType"
                  v-if="badgeIssueBody.activityType !== ''"
                >
                  <el-option
                    v-for="item in activitySelect[badgeIssueBody.mainType][
                      badgeIssueBody.activityType
                    ].subList"
                    :key="item.subName"
                    :label="item.subName"
                    :value="item.subType"
                    @click.native="selectSub"
                  >
                  </el-option>
                  <template slot="empty">
                    <div class="el-select-dropdown__empty">
                      請先選擇徽章名稱
                    </div>
                  </template>
                </el-select>
                <el-select v-model="badgeIssueBody.subType" v-else>
                  <el-option
                    v-for="item in []"
                    :key="item.subName"
                    :label="item.subName"
                    :value="item.subType"
                  >
                  </el-option>
                  <template slot="empty">
                    <div class="el-select-dropdown__empty">
                      請先選擇徽章名稱
                    </div>
                  </template>
                </el-select>
              </div>
            </div>
            <div class="el-message-content-item">
              <label>發放時間</label>
              <el-date-picker
                type="datetime"
                v-model="badgeIssueBody.issueTime"
                placeholder="选择日期时间"
                style="display: block"
              >
              </el-date-picker>
            </div>
            <div class="el-message-content-item">
              <label>發放理由（備註）</label>
              <el-input
                placeholder="例：JJLin生日會-第一次發放"
                v-model="badgeIssueBody.issueName"
                maxlength="100"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button
            type="button"
            class="el-button el-button--default el-button--small"
            @click="openBadgeIssueHistory"
          >
            <span>徽章發放紀錄</span>
          </button>
          <button
            @click="ensureBadgeIssue()"
            type="button"
            class="el-button el-button--default el-button--small el-button--primary "
          >
            <span>發放</span>
          </button>
        </div>
      </div>
    </div>
    <!--确认徽章发放-->
    <div v-if="ensureBadgeIssueFlag" class="propWrap badge-tip">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">發放確認</span>
          </div>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-content-item">
            <div>
              發放的徽章：{{
                activitySelect[badgeIssueBody.mainType][
                  badgeIssueBody.activityType
                ].activityName
              }}
            </div>
            <div>徽章等級：{{ badgeSubRange }}</div>
            <div>發放日期：{{ badgeIssueBody.issueTime | timeFormat }}</div>
            <div>發放人數：{{ badgeIssueBody.list.split("\n").length }}</div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button
            type="button"
            class="el-button el-button--default el-button--small"
            @click="ensureBadgeIssueFlag = false"
          >
            <span>取消</span>
          </button>
          <el-button
            @click="ensureBadgeIssueAgain()"
            type="button"
            :loading="isClick"
          >
            <span>{{ isClick ? "发放中" : "確認發放" }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <!--徽章发放成功-->
    <div v-if="issueSuccessFlag" class="propWrap badge-result">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">徽章發放成功</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="closeResultProp"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-content-item">
            <div>發放理由（備註）：{{ badgeIssueBody.issueName }}</div>
            <div>
              發放的徽章：{{
                activitySelect[badgeIssueBody.mainType][
                  badgeIssueBody.activityType
                ].activityName
              }}
            </div>
            <div>徽章等級：{{ badgeSubRange }}</div>
            <div>
              徽章發放人數：{{ badgeIssueBody.list.split("\n").length }}
            </div>
            <div>徽章發放時間：{{ badgeIssueBody.issueTime | timeFormat }}</div>
            <div>
              發放操作時間：{{ badgeIssueBody.issueOperateTime | timeFormat }}
            </div>
          </div>
        </div>
        <div style="text-align: center">
          <el-button
            @click="exportBadgeHistory(badgeIssueBody.downloadUrl)"
            type="primary"
            >下載發放結果（Excel）</el-button
          >
        </div>
      </div>
    </div>
    <!--徽章发放历史记录-->
    <div v-if="badgeIssueHistoryFlag" class="propWrap badge-table">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">徽章發放紀錄</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="badgeIssueHistoryFlag = false"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="table-content">
            <div class="tableWrap">
              <el-table
                stripe
                :data="badgeIssueHistory"
                :header-cell-style="{ background: '#f3f3fb', color: '#000000' }"
              >
                <el-table-column prop="issueName" label="發放理由（備註）">
                </el-table-column>
                <el-table-column prop="activityName" label="發放徽章">
                </el-table-column>
                <el-table-column prop="subName" label="徽章等級">
                </el-table-column>
                <el-table-column prop="issueTotal" label="發放人數">
                </el-table-column>
                <el-table-column prop="createTime" label="徽章發布時間">
                  <template slot-scope="scope">{{
                    scope.row.createTime | timeFormat
                  }}</template>
                </el-table-column>
                <el-table-column prop="issueTime" label="發放操作時間">
                  <template slot-scope="scope">{{
                    scope.row.issueTime | timeFormat
                  }}</template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="exportBadgeHistory(scope.row.issueUrl)"
                      >下載發放結果
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="paging-block clearfix centerXF">
              <el-pagination
                class="paging fr"
                hide-on-single-page
                @current-change="handleBadgeHistoryPageChange"
                :current-page="badgeCurrentPage"
                :page-size="10"
                :pager-count="5"
                layout="prev, pager, next, jumper"
                :total="badgeTotal"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--補簽卡-->
    <prop-wrap
      v-if="retroactiveIssueFlag"
      :width="'9rem'"
      :height="'6rem'"
      :title="'補簽卡發放'"
      v-on:closeProp="closeRetroactiveForm"
    >
      <div class="retroactive-form">
        <div class="el-message-content-item">
          <label>發放目標（請輸入發給會員郵箱，一行一個）</label>
          <el-input
            type="textarea"
            v-model="retroactiveIssueBody.list"
          ></el-input>
        </div>
        <div class="el-message-content-item">
          <span>發放數量（超出庫存上限10張時，保持補簽卡數量爲10）</span>
          <el-input
            type="text"
            placeholder="請輸入整數，範圍爲1~10"
            v-model="retroactiveIssueBody.issueNum"
            @change="checkRetroactiveNum"
          >
          </el-input>
        </div>
        <div class="el-message-content-item">
          <span>發放理由（備註）</span>
          <el-input
            type="text"
            placeholder="請輸入補簽卡發放理由"
            :controls="false"
            v-model="retroactiveIssueBody.issueName"
            maxlength="100"
          ></el-input>
        </div>
        <div class="el-message-box__btns">
          <button
            type="button"
            class="el-button el-button--default el-button--small"
            @click="openRetroactiveIssueHistory"
          >
            <span>發放紀錄</span>
          </button>
          <button
            @click="retroactiveIssueBtn()"
            type="button"
            :loading="isClick"
            class="el-button el-button--default el-button--small el-button--primary "
          >
            <span>發放</span>
          </button>
        </div>
      </div>
    </prop-wrap>
    <!--补签卡记录-->
    <prop-wrap
      v-if="retroactiveHistoryFlag"
      v-on:closeProp="closeRetroactiveHistory"
      :width="'9rem'"
      :height="'6rem'"
      :title="'補簽卡發放記錄'"
    >
      <div class="retroactive-table">
        <div class="tableWrap">
          <el-table
            stripe
            :data="retroactiveIssueHistory"
            :header-cell-style="{ background: '#f3f3fb', color: '#000000' }"
          >
            <el-table-column prop="issueName" label="發放理由（備註）">
            </el-table-column>
            <el-table-column prop="signCardTotal" label="發放補簽卡數量">
            </el-table-column>
            <el-table-column prop="num" label="發放人數"> </el-table-column>
            <el-table-column prop="issueTime" label="發放操作時間">
              <template slot-scope="scope">{{
                scope.row.issueTime | timeFormat
              }}</template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="exportBadgeHistory(scope.row.issueUrl)"
                  >下載發放結果
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging-block clearfix centerXF">
          <el-pagination
            class="paging fr"
            hide-on-single-page
            @current-change="handleRetroactiveHistoryPageChange"
            :current-page="retroactiveCurrentPage"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next, jumper"
            :total="retroactiveTotal"
          >
          </el-pagination>
        </div>
      </div>
    </prop-wrap>
    <!--补签卡发放成功-->
    <prop-wrap
      v-if="retroactiveIssueSuccessFlag"
      v-on:closeProp="closeRetroactiveResult"
      :width="'7rem'"
      :height="'4rem'"
      :title="'補簽卡發放成功'"
    >
      <div class="retroactive-form">
        <div class="el-message-content-item">
          發放理由（備註）：{{ retroactiveIssueBody.issueName }}
        </div>
        <div class="el-message-content-item">
          發放補簽卡數量：{{ retroactiveIssueBody.issueNum }}
        </div>
        <div class="el-message-content-item">
          發放人數：{{ retroactiveIssueBody.list.split("\n").length }}人
        </div>
        <div class="el-message-content-item">
          補簽卡發放時間：{{ retroactiveIssueBody.issueTime }}
        </div>
        <div style="text-align: center">
          <el-button
            @click="exportBadgeHistory(retroactiveIssueBody.downloadUrl)"
            type="primary"
            >下載發放結果（Excel）
          </el-button>
        </div>
      </div>
    </prop-wrap>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { compareTimeTo13, formatTime } from "../../utils/fn";
import PropWrap from "../../components/propWrap";

export default {
  data() {
    return {
      navBlock: "會員",
      navtitle: "會員列表",
      userInfoList: [],
      listMenuForm: {
        area: "",
        memberStatus: "0", // 会员状态
        authStatus: "4", // 认证状态
        nickname: null, //會員暱稱
        selectValue: "1"
      },
      userInfoTable: [
        {
          prop: "id",
          label: "會員編號",
          width: "160"
        },
        {
          prop: "email",
          label: "會員賬號",
          width: "190"
        },
        {
          prop: "nickname",
          label: "暱稱",
          width: ""
        },
        {
          prop: "realname",
          label: "真實姓名",
          width: "70"
        },
        {
          prop: "mobile",
          label: "手機號碼",
          width: "120"
        },
        {
          prop: "country",
          label: "地區",
          width: "60"
        },

        {
          prop: "roleMember",
          label: "會籍",
          width: "60"
        },
        {
          prop: "type",
          label: "賬號狀態",
          width: "170"
        },
        {
          prop: "authorizationCode",
          label: "實名認證",
          width: "100"
        },
        {
          prop: "startTime",
          label: "VIP起始時間",
          width: "160"
        },
        {
          prop: "endTime",
          label: "VIP到期時間",
          width: "160"
        },
        {
          prop: "createTime",
          label: "會員註冊時間",
          width: "160"
        }
      ],
      currentPage: 1,
      total: 10,
      badgeCurrentPage: 1,
      badgeTotal: 10,
      retroactiveCurrentPage: 1,
      retroactiveTotal: 10,
      addBlacktips: "",
      addBlackFlag: false, // 加入黑名单弹窗
      badgeIssueFlag: false, // 徽章发放弹窗
      badgeIssueHistoryFlag: false, //徽章发放历史记录
      ensureBadgeIssueFlag: false, //發放確認
      issueSuccessFlag: false, // 發放成功
      retroactiveIssueFlag: false, // 补签卡发放窗口
      retroactiveHistoryFlag: false, // 补签卡发放记录
      retroactiveIssueSuccessFlag: false, //发放成功
      addBlackId: "",
      addBlackEmail: "",
      blackReason: "", //黑名單原因
      blackType: 1,
      checkBlackList: [],
      downTime: "", //禁用VIP到期時間
      forbiddenOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000; // 限制只可以选择今天及今天之前的日期
        }
      },
      dialogVisible: false,
      isIndeterminate: true,
      mainSelect: [],
      activitySelect: {},
      badgeIssueBody: {
        mainType: "",
        activityType: "",
        subType: "",
        issueName: "",
        issueTime: "",
        list: "",
        issueOperateTime: "",
        downloadUrl: ""
      },
      retroactiveIssueBody: {
        list: "",
        issueNum: "",
        issueName: "",
        issueTime: "",
        downloadUrl: ""
      },
      badgeSubRange: "",
      badgeIssueHistory: [],
      retroactiveIssueHistory: [],
      isClick: false,
      isDownload: false,
      roleType: "",
      complainFlag: false,
      complainTips: "",
      complainType: "",
      complainUserId: "",
      typeNameArray: [
        { name: "企圖破壞或入侵信息", type: 100 },
        { name: "發佈謾罵、攻擊性言論、侮辱等不當言論", type: 101 },
        { name: "進行非法交易行為", type: 102 },
        { name: "冒充平台或其他用戶身份", type: 103 },
        { name: "侵犯他人知識產權或其他合法權益", type: 104 },
        { name: "故意干擾或破壞平台相關功能", type: 105 },
        { name: "違法或犯罪行為", type: 106 },
        { name: "其他危害行為", type: 107 }
      ],
      type:null
    };
  },
  created() {
    let _this = this;
    // _this.getUserInfoList();
    _this.roleType = localStorage.getItem("roleType");
    _this.getInitBadgeSelect();
  },
  activated() {
    let _this = this;
    _this.getUserInfoList();
    // if (
    //   _this.listMenuForm.selectValue === "3" &&
    //   _this.listMenuForm.area === "" &&
    //   _this.listMenuForm.nickname === "" &&
    //   _this.listMenuForm.memberStatus === "0" &&
    //   _this.listMenuForm.authStatus === "4" &&
    //   _this.currentPage === 1
    // ) {
    //   _this.getUserInfoList();
    // }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 管理員檢舉用戶
    complainUser(row) {
      this.complainTips = `是否檢舉${row.nickname}用戶違反以下：`;
      this.complainFlag = true;
      this.complainUserId = row.id;
    },
    cancelComplain() {
      this.complainFlag = false;
      this.complainUserId = "";
      this.complainType = "";
    },
    confirmComplainUser() {
      if (!this.complainType) {
        this.$message({
          message: "請選擇檢舉類型",
          type: "error",
          center: true
        });
        this.cancelComplain();
        return;
      }
      let compplainParams = {
        userId: this.complainUserId,
        complaintType: this.complainType
      };
      this.$post(
        "/request/complains/user/add",
        compplainParams,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        // console.log(res);
        if (res.code === "00000") {
          this.$message({
            message: "檢舉成功",
            type: "success",
            center: true
          });
          this.cancelComplain();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            center: true
          });
          this.cancelComplain();
        }
      });
    },
    // 限制禁用时间只能是当前时间之后
    handleForbidTime() {
      var startAt = (new Date(this.downTime) * 1000) / 1000;
      if (startAt < Date.now()) {
        this.downTime = new Date();
      }
    },
    // phoneChange(val) {
    //   let _this = this;
    //   _this.listMenuForm.phone = _this.listMenuForm.phone.replace(/\D/g, '');
    // },
    // 获取用户列表和导出所有会员的参数
    getparam() {
      let _this = this;
      let area,
        city,
        country,
        role = null;
      // 会员类型
      if (
        _this.listMenuForm.memberStatus === "" ||
        _this.listMenuForm.memberStatus === "0"
      ) {
        role = null;
      } else if (_this.listMenuForm.memberStatus === "1") {
        role = "vip";
      } else if (_this.listMenuForm.memberStatus === "2") {
        role = "user";
      } else if (_this.listMenuForm.memberStatus === "3") {
        role = null;
      }
      let param = {
        id:
          _this.listMenuForm.selectValue === "4"
            ? _this.listMenuForm.nickname
            : null,
        email:
          _this.listMenuForm.selectValue === "1"
            ? _this.listMenuForm.nickname
            : null,
        realname:
          _this.listMenuForm.selectValue === "2"
            ? _this.listMenuForm.nickname
            : null,
        area: null,
        city: null,
        country:
          _this.listMenuForm.area === "" ? null : _this.listMenuForm.area,
        mobile:
          _this.listMenuForm.selectValue === "3"
            ? _this.listMenuForm.nickname
            : null,
        role: role,
        pageNo: _this.currentPage,
        pageSize: 10,
        nickname:
          _this.listMenuForm.selectValue === "0"
            ? _this.listMenuForm.nickname
            : null,
        idCard:
          _this.listMenuForm.selectValue === "5"
            ? _this.listMenuForm.nickname
            : null,
        type:this.type?this.type:null
      };
      if (_this.listMenuForm.memberStatus === "3") {
        param.blackList = "1";
      }
      if (_this.listMenuForm.authStatus != "4") {
        param.authorizationCode = Number(_this.listMenuForm.authStatus);
      }
      return param;
    },
    // 获取用户列表
    getUserInfoList() {
      let _this = this;
      _this
        .$post(
          "/request/member/findMembers",
          _this.getparam(),
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            res.data.list.forEach(v => {
              v.region =
                (v.country === null ? "" : v.country) +
                " " +
                (v.city === null ? "" : v.city) +
                "" +
                (v.area === null ? "" : v.area);
              v.cardNumber = v.idcardNumber === null ? "" : v.idcardNumber;
              if (v.blackList == "1" || v.blackList == "2") {
                v.roleMember = "黑名單";
              } else {
                if (v.role === "user") {
                  v.roleMember = "一般";
                } else if (v.role === "vip") {
                  v.roleMember = "VIP";
                }
              }
              v.mobile =
                (v.areaCode == null ? "" : "+" + v.areaCode) +
                " " +
                (v.mobile == null ? "" : v.mobile);
              v.startTime =
                v.startTime == null ? "" : v.startTime.substring(0, 16);
              v.endTime = v.endTime == null ? "" : v.endTime.substring(0, 16);
            });
            _this.userInfoList = res.data.list;
          } else {
            if (res.code === "50001") {
              _this.total = 0;
              _this.userInfoList = [];
            }
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserInfoList();
    },

    handleBadgeHistoryPageChange(val) {
      let _this = this;
      _this.badgeCurrentPage = val;
      _this.getBadgeIssueHistory();
    },

    handleRetroactiveHistoryPageChange(val) {
      let _this = this;
      _this.retroactiveCurrentPage = val;
      _this.getRetroactiveIssueHistory();
    },
    // 地区选择
    handleAreaChange(val) {
      let _this = this;
      _this.listMenuForm.area = _this.$refs[
        "cascaderAddr"
      ].getCheckedNodes()[0].pathLabels;
    },
    // 查詢
    search() {
      let _this = this;
      // console.log(_this.listMenuForm);
      
      // if (
      //   _this.listMenuForm.area == "" &&
      //   _this.listMenuForm.nickname == "" &&
      //   _this.listMenuForm.memberStatus == "0" &&
      //   _this.listMenuForm.authStatus == "4"
      // ) {
      //   _this.dialogVisible = true;
      //   _this.$propMessage("請輸入至少一個搜索條件", "error", function() {
      //     _this.dialogVisible = false;
      //   });
      //   return false;
      // }
      // _this.$message.closeAll();
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        selectValue: "1",
        area: "",
        memberStatus: "0",
        authStatus: "4",
        nickname: null
      };
      _this.type=null;
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 修改用戶信息
    toEdituser(id,type) {
      this.$router.push("/userDetails?id=" + id);
    },
    // 刪除用戶
    delUser(id, email) {
      let _this = this;
      _this
        .$confirm(
          `是否將賬號為${email}的用戶刪除，刪除後對應的其他訊息將保留（例如評論、訂單）賬號將無法恢復`,
          "提示信息",
          {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          }
        )
        .then(() => {
          _this
            .$get(
              `/request/member/delMember?id=${id}&email=${email}`,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("刪除成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.getUserInfoList();
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    //將用戶加入黑名單
    blackUser(id, email, flag) {
      let _this = this;
      let tipText = "";
      let successText = "";
      _this.checkBlackList = [];
      _this.downTime = "";
      _this.blackReason = "";
      if (flag === 1) {
        _this.addBlackFlag = true;
        _this.addBlackId = id;
        _this.addBlackEmail = email;
        _this.addBlacktips = `是否將賬號為${email}的用戶加入黑名單，加入後，用戶將無法用此賬號登錄或註冊，詳情可以在黑名單列表中查看`;
      } else if (flag === 0) {
        tipText = `是否將賬號為${email}的用戶移出黑名單，移出後，用戶將正常使用該賬戶所有功能`;
        successText = "將用戶移出黑名單成功，請稍後~";
        _this
          .$confirm(tipText, "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            // flag為1則為黑名單用戶，0反之
            _this
              .$get(
                `/request/member/addBlackList?id=${id}&blackListDetails=&flag=${flag}&email=${email}`,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage(successText, "success", function() {
                    _this.dialogVisible = false;
                    _this.getUserInfoList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          })
          .catch(() => {});
      }
    },

    // 徽章管理
    badgeManager(id) {
      this.$router.push("/badgeManager?id=" + id);
    },

    cancelAddBlack() {
      this.addBlackFlag = false;
      this.checkBlackList = [];
      this.blackReason = "";
      this.downTime = "";
    },

    addBlack(id, email) {
      let _this = this;
      if (_this.blackReason !== "" && _this.$getCaption(_this.blackReason)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "加入黑名單原因不能包含非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );

        return false;
      }
      if (_this.downTime === "" || _this.downTime === null) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇禁用到期時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      let param = {
        userId: id,
        blackList:
          _this.checkBlackList.length === 1
            ? _this.checkBlackList[0]
            : _this.checkBlackList.join(","),
        blackListContent: _this.blackReason,
        downTime: _this.$formatDate(_this.downTime)
      };
      if (_this.checkBlackList.length == 0) {
        param.blackList = "6";
      }
      _this
        .$put(
          `request/blackMember/saveBlackList`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.$propMessage("將用戶加入黑名單成功", "success", function() {
              _this.dialogVisible = false;
              _this.addBlackId = "";
              _this.addBlackEmail = "";
              _this.addBlackFlag = false;
              _this.blackReason = "";
              _this.getUserInfoList();
            });
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    // 导出excel
    exportExcel() {
      let _this = this;
      let url = `/request/member/exportMemberExcel?pageNo=1&pageSize=99999999&role=vip`;
      _this.$exportExcel(url, "GET", {}, "會員列表");
    },

    handleCheckedTypeChange(value) {
      // let _this = this;
      console.log(value);
      // console.log(_this.checkBlackList)
      // let length = _this.checkBlackList.length
      // if(_this.checkBlackList[length-1]==3){
      //   _this.checkBlackList = [3]
      // } else {
      //   _this.checkBlackList.some(function(x){
      //     console.log(x === 3)
      //     if(x === 3) {
      //       console.log(_this.checkBlackList.indexOf(3));
      //       _this.checkBlackList.splice(_this.checkBlackList.indexOf(3),1)
      //       // _this.checkBlackList=[3]
      //     }
      //   })
      // }
    },

    // 徽章发放
    badgeIssue() {
      this.badgeIssueFlag = true;
    },
    getScreen(id, screenshot, email) {
      let _this = this;
      let text = screenshot == 0 ? "允許" : "禁止";
      let operate = screenshot == 0 ? 1 : 0;
      _this
        .$confirm(`是否${text}${email}進行截屏操作？`, "提示", {
          confirmButtonText: text,
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$post(
              `/request/member/screenshot/operate`,
              { id: id, operate: operate },
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("操作成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.getUserInfoList();
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    // 补签卡
    retroactiveIssue() {
      this.retroactiveIssueFlag = true;
    },

    // 关闭补签卡
    closeRetroactiveForm(data) {
      this.retroactiveIssueFlag = data;
      this.retroactiveIssueBody.issueTime = "";
      this.retroactiveIssueBody.list = "";
      this.retroactiveIssueBody.issueNum = "";
      this.retroactiveIssueBody.issueName = "";
      this.retroactiveIssueBody.downloadUrl = "";
    },

    // 关闭补签卡历史
    closeRetroactiveHistory(data) {
      this.retroactiveHistoryFlag = data;
    },

    // 关闭补签发放成功
    closeRetroactiveResult(data) {
      this.retroactiveIssueBody.issueTime = "";
      this.retroactiveIssueBody.list = "";
      this.retroactiveIssueBody.issueNum = "";
      this.retroactiveIssueBody.issueName = "";
      this.retroactiveIssueBody.downloadUrl = "";
      this.retroactiveIssueSuccessFlag = data;
    },

    // 初始化徽章下拉框
    getInitBadgeSelect() {
      let _this = this;
      _this
        .$get("/request/badge/electBadge", {}, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code === "00000") {
            console.log(res.data);
            res.data.forEach(v => {
              _this.mainSelect.push({
                mainName: v.mainName,
                mainType: v.mainType
              });
              let mt = v.mainType;
              _this.activitySelect[mt] = {};
              v.activityList.forEach(vv => {
                let at = vv.activityType;
                _this.activitySelect[mt][at] = {
                  activityName: vv.activityName,
                  activityType: vv.activityType,
                  subList: vv.subList
                };
              });
            });
          }
        });
    },

    // 关闭徽章发放页面
    closeBadgeIssueProp() {
      this.badgeIssueFlag = false;
      this.badgeIssueBody.mainType = "";
      this.badgeIssueBody.activityType = "";
      this.badgeIssueBody.subType = "";
      this.badgeIssueBody.issueName = "";
      this.badgeIssueBody.issueTime = "";
      this.badgeIssueBody.list = "";
    },

    closeResultProp() {
      this.issueSuccessFlag = false;
      this.badgeIssueBody.mainType = "";
      this.badgeIssueBody.activityType = "";
      this.badgeIssueBody.subType = "";
      this.badgeIssueBody.issueName = "";
      this.badgeIssueBody.issueTime = "";
      this.badgeIssueBody.list = "";
    },

    // 确定分发徽章
    ensureBadgeIssue() {
      let _this = this;
      if (this.badgeIssueBody.list === "") {
        _this.dialogVisible = true;
        _this.$propMessage("發放目標為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.badgeIssueBody.mainType === "") {
        _this.dialogVisible = true;
        _this.$propMessage("徽章種類未選", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.badgeIssueBody.activityType === "") {
        _this.dialogVisible = true;
        _this.$propMessage("徽章名稱未選", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.badgeIssueBody.subType === "") {
        _this.dialogVisible = true;
        _this.$propMessage("徽章等級未選", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (
        this.badgeIssueBody.issueTime === "" ||
        this.badgeIssueBody.issueTime === null
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("發放時間未選", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.badgeIssueBody.issueName === "") {
        _this.dialogVisible = true;
        _this.$propMessage("發放理由（備註）為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.badgeIssueBody.list.split("\n").length > 1000) {
        _this.dialogVisible = true;
        _this.$propMessage("發放目標最多一千個", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.$compareTime(_this.badgeIssueBody.issueTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("發放時間不可以是未來時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (compareTimeTo13(_this.badgeIssueBody.issueTime)) {
        _this.dialogVisible = true;
        _this.$propMessage("發放時間不可以在2013年之前", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      this.ensureBadgeIssueFlag = true;
    },

    // 發放確認
    ensureBadgeIssueAgain() {
      let _this = this;
      let list = this.badgeIssueBody.list.split("\n");
      let params = {
        activityType: this.badgeIssueBody.activityType,
        issueName: this.badgeIssueBody.issueName,
        issueTime: this.badgeIssueBody.issueTime,
        mainType: this.badgeIssueBody.mainType,
        subType: this.badgeIssueBody.subType,
        list: list
      };

      if (!_this.isClick) {
        _this.isClick = true;
        _this
          .$post("/request/badge/batch/save", params, _this.$GLOBAL.jsonConfig)
          .then(res => {
            if (res.code === "00000") {
              this.badgeIssueBody.issueOperateTime = new Date().getTime();
              this.badgeIssueBody.downloadUrl = res.data;
              _this.ensureBadgeIssueFlag = false;
              this.issueSuccessFlag = true;
              _this.isClick = false;
            } else {
              _this.dialogVisible = true;
              _this.$propMessage(res.message, "error", function() {
                _this.dialogVisible = false;
                _this.isClick = false;
              });
              return false;
            }
          });
      }
      // this.badgeIssueBody.mainType = ''
      // this.badgeIssueBody.activityType = ''
      // this.badgeIssueBody.subType = ''
      // this.badgeIssueBody.issueName = ''
      // this.badgeIssueBody.issueTime = ''
      // this.badgeIssueBody.list = ''
    },

    // 发放数量检查
    checkRetroactiveNum(val) {
      this.retroactiveIssueBody.issueNum = Number(val.replace(/\D/g, ""));
      console.log(this.retroactiveIssueBody.issueNum);
      if (this.retroactiveIssueBody.issueNum <= 0) {
        this.retroactiveIssueBody.issueNum = 1;
      } else if (this.retroactiveIssueBody.issueNum > 10) {
        this.retroactiveIssueBody.issueNum = 10;
      }
    },

    // 补签发放
    retroactiveIssueBtn() {
      let _this = this;
      if (this.retroactiveIssueBody.list === "") {
        _this.dialogVisible = true;
        _this.$propMessage("發放目標為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.retroactiveIssueBody.issueNum === "") {
        _this.dialogVisible = true;
        _this.$propMessage("發放數量為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.retroactiveIssueBody.issueName === "") {
        _this.dialogVisible = true;
        _this.$propMessage("發放理由為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      let list = this.retroactiveIssueBody.list.split("\n");
      let params = {
        issueName: this.retroactiveIssueBody.issueName,
        num: this.retroactiveIssueBody.issueNum,
        list: list
      };
      if (!_this.isClick) {
        _this.isClick = true;
        _this
          .$post(
            `/request/retroactive/batch/save`,
            params,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            if (res.code === "00000") {
              this.retroactiveIssueBody.issueTime = res.data
                .split("（")[1]
                .split("）")[0];
              this.retroactiveIssueBody.downloadUrl = res.data;
              this.retroactiveIssueSuccessFlag = true;
              _this.isClick = false;
            } else {
              _this.dialogVisible = true;
              _this.$propMessage(res.message, "error", function() {
                _this.dialogVisible = false;
                _this.isClick = false;
              });
              return false;
            }
          });
      }
    },

    // 打开徽章记录弹窗
    openBadgeIssueHistory() {
      this.badgeIssueHistoryFlag = true;
      this.getBadgeIssueHistory();
    },

    // 打开补签历史
    openRetroactiveIssueHistory() {
      this.retroactiveHistoryFlag = true;
      this.getRetroactiveIssueHistory();
    },

    // 查看分发徽章记录
    getBadgeIssueHistory() {
      let _this = this;
      _this
        .$get(
          `/request/badge/record?pageNo=${_this.badgeCurrentPage}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            this.badgeIssueHistory = res.data.list;
            this.badgeTotal = res.data.total;
          }
        });
    },

    // 查看补签卡历史记录
    getRetroactiveIssueHistory() {
      let _this = this;
      _this
        .$get(
          `/request/retroactive/record?pageNo=${_this.retroactiveCurrentPage}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            this.retroactiveIssueHistory = res.data.list;
            this.retroactiveTotal = res.data.total;
          }
        });
    },

    // 下载发放结果
    exportBadgeHistory(url) {
      let _this = this;
      if (!_this.isDownload) {
        _this.isDownload = true;
        let a = document.createElement("a");
        a.href = url;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          _this.isDownload = false;
        }, 2000);
      }
    },
    selectSub() {
      let data = this.activitySelect[this.badgeIssueBody.mainType][
        this.badgeIssueBody.activityType
      ];
      let obj = {};
      obj = data.subList.find(item => {
        //这里的userList就是上面遍历的数据源
        return item.subType === this.badgeIssueBody.subType; //筛选出匹配数据
      });
      this.badgeSubRange = obj.subName;
    },
    // 關閉補簽卡
    closeIssue(data) {
      this.retroactiveIssueFlag = data;
    }
  },
  filters: {
    timeFormat(time) {
      return formatTime(time);
    }
  },
  components: {
    PropWrap,
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;

    .ListMenu {
      display: flex;
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}

@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      // .searchItem{
      //     flex: 1;
      // }
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }

  .propWrap {
    display: flex;
    justify-content: center;
    align-items: center;

    .prop-content {
      height: 40%;
      overflow: auto;

      .icon-close {
        padding: 0.2rem;
      }
    }
  }
}

.badge-form {
  .el-message-box {
    width: 7rem;
    height: 6rem;
    overflow-y: auto;
  }

  .el-message-box__content {
    margin-top: 0.16rem;
    padding: 0 0.92rem 0 0.92rem;
    margin-bottom: 0.27rem;
    line-height: 0.24rem;

    .el-message-content-item {
      text-align: left;
      margin-bottom: 0.2rem;

      label {
        font-size: 0.14rem;
      }
    }

    .flex-content {
      display: flex;

      .flex-item {
        flex: 1;
        margin-right: 0.3rem;
      }

      .flex-item:last-child {
        margin-right: 0;
      }
    }
  }
}

.badge-table {
  .el-message-box {
    width: 11.8rem;
    height: 6.93rem;
  }

  .el-message-box__content {
    margin-top: 0.33rem;

    .table-content {
      width: 100%;

      .tableWrap {
        width: 100%;
        height: 4.7rem;
        background: #fff;
        margin-top: 0;
        border-radius: 12px;
        overflow: auto;
        box-shadow: 0 6px 18px rgba(227, 227, 241, 1);
      }
    }
  }
}

.badge-tip,
.badge-result {
  .el-message-box {
    width: 5.6rem;
    height: 3.23rem;
  }

  .el-message-box__content {
    width: 100%;
    padding-left: 0;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    line-height: 0.3rem;

    .el-message-content-item {
      text-align: left;

      label {
        font-size: 0.14rem;
      }
    }
  }
}

.badge-result {
  .el-message-box {
    height: 3.5rem;
  }
}

.retroactive-form {
  padding: 0.3rem 1.9rem 0.8rem 1.9rem;
  text-align: left;
  height: 100%;

  .el-message-content-item {
    margin-bottom: 0.2rem;

    label {
      font-size: 0.14rem;
    }
  }

  .el-message-box__btns {
    margin-top: 0.5rem;
  }
}

.retroactive-table {
  padding: 0.24rem 0.11rem 0.3rem 0.11rem;

  .tableWrap {
    width: 100%;
    height: 4.3rem;
    min-height: 4.3rem;
    background: #fff;
    margin-top: 0;
    border-radius: 12px;
    overflow: auto;
    box-shadow: 0 6px 18px rgba(227, 227, 241, 1);
  }
}

div::-webkit-scrollbar-track {
  background-color: transparent;
}

.prop-title {
  font-size: 0.16rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userInfo.vue